module.exports = __webpack_public_path__ + "img/doctor-ajolito.04e9f5ba.svg";